async function post(path, body, token) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.message || `Request to ${path} failed`);
  if (data && data.success === false) throw new Error(data.message || `Request to ${path} failed`);
  return data;
}

// War cry (video or audio) uploads straight to S3 via a presigned URL instead of through our own
// API — same reasoning as checkpoint media submissions: API Gateway hard-caps request bodies at
// ~10MB, and a real recorded video clip routinely exceeds that.
export async function saveWarCry({ token, stageId, userId, mediaBlob, fileExt, mediaType }) {
  const fileName = `warcry.${fileExt || (mediaType === "video" ? "webm" : "webm")}`;
  const presign = await post(
    "/getWarCryUploadUrl",
    { stageId, userId, fileName, contentType: mediaBlob.type || "", mediaType },
    token
  );

  const putResp = await fetch(presign.uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": presign.contentType || mediaBlob.type || "application/octet-stream" },
    body: mediaBlob,
  });
  if (!putResp.ok) {
    throw new Error("Failed to upload — check your connection and try again.");
  }

  return post("/saveWarCry", { stageId, userId, filename: presign.filename }, token);
}
